import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { queryClient } from '~/common/react-query/queryClient'
import { Prettify } from '~/common/type-helpers'
import fetch from '~/common/fetch'

export type OffsetLimit = {
  offset: number
  limit: number
}

export type OffsetLimitPaginationResponse<T> = Prettify<
  OffsetLimit & {
    results: T[]
    count: number
    page: number
    total_pages: number
    next_link: null | string
    next_params: null | OffsetLimit
    previous_link: null | string
    previous_params: null | OffsetLimit
  }
>

export type StandardErrorError = {
  code: string
  detail: string
  attr: string | null
}

export type StandardError = {
  title: string
  message: string
  type: 'server_error' | 'client_error' | 'validation_error'
  errors: StandardErrorError[]
}

// TQueryFnData is the data that the API returns
// TData is the data shape the hook returns after any `select` transformation
// if no `select` is used TData defaults to TQueryFnData
export const useSimpleGetQuery = <TQueryFnData = unknown, TData = TQueryFnData>(
  url: string,
  config?: UseQueryOptions<TQueryFnData, unknown, TData>
) => {
  return useQuery<TQueryFnData, unknown, TData>({
    queryKey: url.split('/'),
    queryFn: () => fetch.get(url),
    staleTime: 5 * 60 * 1000,
    ...config
  })
}

export const invalidateSimpleGetQuery = async (url: string) => {
  await queryClient.invalidateQueries(url.split('/'))
}
